import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as ListingsActions from './listings.actions';
import { LISTINGS } from './listings.mock';

@Injectable()
export class ListingsEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ListingsActions.init),
      map((action) => {
        // Your custom service 'load' logic goes here. For now just return a success action...
        return ListingsActions.loadListingsSuccess({ listings: LISTINGS });
      }),
      catchError((error: unknown) => {
        console.error('Error', error);
        return of(ListingsActions.loadListingsFailure({ error }));
      })
    )
  );

  constructor(private actions$: Actions) {}
}
